import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial S/C;</li>
                            <li>Axial C/C Fase arterial;</li>
                            <li>Axial C/C Fase venosa;</li>
                            <li>Coronal S/C;</li>
                            <li>Coronal C/C Fase arterial;</li>
                            <li>Coronal C/C Fase venosa;</li>
                            <li>Sagital S/C;</li>
                            <li>Sagital C/C Fase arterial;</li>
                            <li>Sagital C/C Fase venosa;</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}